import Modal from 'storybookConfig/stories/cells/Modal';
import LeftMenu from '../LeftMenu';
import { type RootState, useAppDispatch, useAppSelector } from 'store/index';
import { closeMobileMenu } from 'store/slices/sidebar';
import { useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import Hamburger from './Hamburger';
import Heading from 'storybookConfig/stories/molecules/Heading';

const HeadingBuffer = styled.div`
  height: 50px;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: baseline;
  gap: 12px;
  width: 100%;
  position: fixed;
  box-sizing: border-box;
  top: 0;
  background: white;
  z-index: 1000;
  transition: transform 0.3s ease-in-out;
  min-height: 50px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 0 16px;
  width: 100%;
`;

interface MobileMenuProps {
  showDefaultHeader: boolean;
}

const MobileMenu = ({ showDefaultHeader }: MobileMenuProps) => {
  const { mobileMenuExpanded } = useAppSelector((state: RootState) => state.sidebar);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const prevPathname = useRef(location.pathname);

  useEffect(() => {
    // Close the mobile menu if the pathname changes

    if (mobileMenuExpanded && prevPathname.current !== location.pathname) {
      dispatch(closeMobileMenu());
    }

    prevPathname.current = location.pathname;
  }, [location.pathname, dispatch, mobileMenuExpanded]);

  return (
    <>
      {showDefaultHeader && (
        <>
          <HeadingBuffer />
          <HeaderContainer>
            <Hamburger />
            <Heading>carro</Heading>
          </HeaderContainer>
        </>
      )}
      {mobileMenuExpanded && (
        <Modal.Root
          show={mobileMenuExpanded}
          onHide={() => dispatch(closeMobileMenu())}
          centered
          fullScreen
        >
          <Modal.Header closeButton>Carro</Modal.Header>

          <LeftMenu />
        </Modal.Root>
      )}
    </>
  );
};

export default MobileMenu;
